import { render, staticRenderFns } from "./CreditsHistoryEmpty.vue?vue&type=template&id=051127b6&scoped=true&"
import script from "./CreditsHistoryEmpty.vue?vue&type=script&lang=ts&"
export * from "./CreditsHistoryEmpty.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051127b6",
  null
  
)

export default component.exports